import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CognitoUtil } from './cognito.service';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { IBrokerInfo } from 'app/interface/brokerinfo';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { UpdateBrokerIdRequest } from 'app/models/updateBrokerIdRequest';
import { IBrokerReferralModel } from 'app/interface/IBrokerReferralModel';

@Injectable({
  providedIn: 'root'
})
export class BrokerService {

  public static _API_ENDPOINT = environment.apiEndPoint;

  constructor(private http: HttpClient, private cognitoUtil: CognitoUtil, private router: Router) { }
  createOptions() {
    this.cognitoUtil.refresh();
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('AWSCreds'),
        'Identity': localStorage.getItem('CognitoId'),
        'Sub': localStorage.getItem('CognitoSub')
      })
    }
  }

  getOrCreateBroker = () => {
    return this.http.get<IBrokerInfo>(BrokerService._API_ENDPOINT + 'Broker/GetOrCreateBroker', this.createOptions())
      .pipe(
        catchError(this.handleError),
        map((response) => <IBrokerInfo>(response))
      );
  }

  getBrokerReferrals = () => {
    return this.http.get<IBrokerReferralModel[]>(BrokerService._API_ENDPOINT + 'Broker/GetBrokerReferrals', this.createOptions())
      .pipe(
        catchError(this.handleError),
        map((response) => <IBrokerReferralModel[]>(response))
      );
  }

  updateBrokerId = (brokerId: UpdateBrokerIdRequest) =>{
    return this.http.put<IBrokerInfo>(BrokerService._API_ENDPOINT + 'Broker/UpdateBrokerId', brokerId,this.createOptions())
    .pipe(
      catchError(this.handleError),
      map((response) => <IBrokerInfo>(response))
    );
  }

  getBroker = () => {
    return this.http.get<IBrokerInfo>(BrokerService._API_ENDPOINT + 'Broker/GetBroker', this.createOptions())
      .pipe(
        catchError(this.handleError),
        map((response) => <IBrokerInfo>(response))
      );
  }
  
  handleError(error: HttpErrorResponse | any) {
    let errMsg: string;
    if (error.status === 403) {
      this.router.navigate(['/logout']);
    }
    if (error.error) {
      const body = error.error;
      if (body.message) {
        errMsg = body.message;
      } else if (body.Message) {
        errMsg = body.Message;
      }
      else {
        const err = body;
        errMsg = `${error.statusText || ''} ${err}`;
      }
    } else {
      errMsg = error.message ? error.message : error.toString();
      if (errMsg.length === 0) {
        errMsg = 'There was an unknown error.  Please try again later';
      }
    }
    return throwError(errMsg);
  }
}
